import { makeStyles } from '@material-ui/core';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import RadioGroup from './index';

const useStyles = makeStyles(() => ({
  radioGroup: { height: ({ height }) => height },
}));

function FormikRadioGroup(props) {
  const { fieldConfig, FieldHelperTextProps, height, className, ...others } = props;
  const classes = useStyles({ height });
  const [field, meta] = useField(fieldConfig);

  return (
    <div>
      <RadioGroup className={`${classes.radioGroup} ${className}`} {...field} {...others} />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </div>
  );
}
FormikRadioGroup.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  className: PropTypes.string,
  height: PropTypes.number,
};

FormikRadioGroup.defaultProps = {
  FieldHelperTextProps: undefined,
  className: '',
  height: 40,
};
export default FormikRadioGroup;
